var _desc, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 9C18 13.97 13.97 18 9 18C4.02 18 0 13.97 0 9C0 4.02 4.02 0 9 0C13.97 0 18 4.02 18 9ZM10.71 16.47Q9.87 16.66 9 16.66Q8.12 16.66 7.28 16.47Q6.63 16.32 6.01 16.06Q5.37 15.79 4.8 15.42Q4.14 14.99 3.57 14.42Q3 13.85 2.57 13.19Q2.2 12.62 1.93 11.98Q1.67 11.36 1.52 10.71Q1.33 9.87 1.33 9Q1.33 8.12 1.52 7.28Q1.67 6.63 1.93 6.01Q2.2 5.37 2.57 4.8Q3 4.14 3.57 3.57Q4.14 3 4.8 2.57Q5.37 2.2 6.01 1.93Q6.63 1.67 7.28 1.52Q8.12 1.33 9 1.33Q9.87 1.33 10.71 1.52Q11.36 1.67 11.98 1.93Q12.62 2.2 13.19 2.57Q13.85 3 14.42 3.57Q14.99 4.14 15.42 4.8Q15.79 5.37 16.06 6.01Q16.32 6.63 16.47 7.28Q16.66 8.12 16.66 9Q16.66 9.87 16.47 10.71Q16.32 11.36 16.06 11.98Q15.79 12.62 15.42 13.19Q14.99 13.85 14.42 14.42Q13.85 14.99 13.19 15.42Q12.62 15.79 11.98 16.06Q11.36 16.32 10.71 16.47Z",
    fill: "#0000AC",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 5.53L9 9L12.51 13.09",
    stroke: "#0000AC",
    strokeOpacity: 1,
    strokeWidth: 0.666474,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.42225089bcb15d22cc599430a7bb145d.svg";
export { ForwardRef as ReactComponent };